// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ab46805ecd3f235012c0","453":"07f08e3360ae09d250c0"}[chunkId] + ".js";
};